import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues } from 'utils';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';

const Awards = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`${res?.title}-${res?.year}`} style={styles.detailBox}>
								<View style={styles.detailBoxContent}>
									<Text style={styles.detailText}>{res?.title}</Text>
									<Text style={styles.detailSubText}>{res?.year}</Text>
									{res?.description && (
										<Text style={styles.detailSubText}>{parse(sanitizeHtml(res.description))}</Text>
									)}
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Awards;
